import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { NotificationsService } from "angular2-notifications";
import { MatDialog } from "@angular/material/dialog";
import { heicTo } from "heic-to";
import { PopupEndPoint } from "../../../modules/inspection/models/create-inspection.model";
import { InterpretationService } from "../../../modules/interpretation/interpretation.service";
import { AddComponentPhotoModel } from "../../../modules/interpretation/models/interpretation.model";
import { EqualiserBarImages } from "../../../entities/setup/model";

@Component({
  selector: "app-add-new-photo",
  templateUrl: "./add-new-photo-component.html",
  styleUrls: ["./add-new-photo-component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNewPhotoComponentComponent implements OnInit, AfterViewInit {
  @Input() componentModel: any;
  @Input() inspectionId: number;
  @Input() inspectionDetailId: number;
  @Input() comingFrom: PopupEndPoint;
  @Input() systemId: number;
  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();
  @Output() SystemPhotoUpload: EventEmitter<any> = new EventEmitter();
  photo = "";
  photoLoading = false;
  constructor(
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {}
  ngAfterViewInit() {
    this._cdr.detach();
  }

  sucessfullyUploaded(title: string,message: string,image?: EqualiserBarImages) {
    this._notify.success(title, message);
    this.SystemPhotoUpload.emit(image);
    this.photoLoading = false;
    this._cdr.detectChanges();
  }

  errorMessage(title: string, message: string, err) {
    console.error(err);
    this.photoLoading = false;
    this._notify.error(title, message);
    this._cdr.detectChanges();
  }

  uploadPhoto(newPhoto: string) {
    this.photoLoading = true;
    this._cdr.detectChanges();
    const photo = new AddComponentPhotoModel();
    photo.InspectionId = this.inspectionId;
    photo.NewPhoto = newPhoto;
    photo.InspectionDetailId = this.inspectionDetailId;
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.InterpretationComponent:
          this._interp.EqBarInspPhoto(photo).subscribe(
            (p) => {
              if (p.m_Item1 > 0) {
                this.sucessfullyUploaded("Uploaded", p.m_Item2, p.m_Item1);
              } else {
                this._notify.error(
                  "Failed",
                  "Unable to upload the photo. Please contact TrackTreads support. ",
                );
                console.error(p.m_Item2);
                this._cdr.detectChanges();
              }
              this.photoLoading = false;
            },
            (err) => {
              this.photoLoading = false;
              this.errorMessage(
                "Failed",
                "Unable to upload the photo. Please contact TrackTreads support. ",
                err,
              );
            },
          );
          break;
        case PopupEndPoint.AddNewInspectionComponent:
        case PopupEndPoint.CreateEditInspectionComponent:
          this._interp.addEqBarPhotoPath(photo).subscribe(
            (r) => {
              if (r && r.ImagePath && r.ImageUrl) {
                const image: EqualiserBarImages = {
  ImageId: 0,
  InspectionId: this.inspectionId,
  SystemId: this.systemId,
  ImagePath: r.ImagePath,
  ImageUrl: r.ImageUrl,
  IsDeleted: false
};
                this.sucessfullyUploaded(
                  "Uploaded",
                  "Photo uploaded successfully.",
                  image,
                );
              } else {
                this.photoLoading = false;
                this._notify.error("Failed", "Unable to upload the photo.");
                this._cdr.detectChanges();
              }
            },
            (err) => {
              this.errorMessage("Failed", "Unable to upload the photo.", err);
            },
          );

          break;
      }
    }
  }

  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement("canvas");
        let width, height;
        width = img.width;
        height = img.height;
        console.log("width", width);
        console.log("height", height);
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800; //643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext("2d");
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      };
      img.onerror = (error) => rej(error);
    });
  }

  async onSelectPhoto(event: any) {
    if (!(event.target.files && event.target.files[0])) {
      return;
    }
    this.photoLoading = true;
    this._cdr.detectChanges();
    const file = event.target.files[0];
    const extension = file.name.split(".").pop()?.toLowerCase();
    const isHeic = extension === "heic" || extension === "heif";
    const processFile = (f: File) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.compressImage(e.target.result).then((res: string) => {
          if (res) {
            this.uploadPhoto(res.split(",")[1]);
          }
        });
      };
      reader.readAsDataURL(f);
    };
    try {
      if (isHeic) {
        const blob = await heicTo({
          blob: file,
          type: "image/jpeg",
          quality: 0.8,
        });
        processFile(
          new File([blob], "converted.jpg", {
            type: "image/jpeg",
          }),
        );
      } else {
        processFile(file);
      }
    } catch (err) {
      this.photoLoading = false;
      console.error(err);
      this._notify.error(
        "Unsupported HEIC",
        "Unable to convert this HEIC image.",
      );
    }
    event.target.value = null;
  }
}
